import {
  getCompleteDataFormValues,
  getQuotation,
  getUserData,
} from 'app/services/businessFunctionHelpers';
import {
  FieldsEnum,
  FormsEnum,
  MessagesEnum,
  ModelPathEnum,
} from 'app/shared/enums';
import checkIfPeselIsMatchingLicenseDate from 'app/services/businessFunctions/helpers/checkIfPeselIsMatchingLicenseDate';
import { setFamilyNameVisibility } from 'app/services/businessFunctions/helpers/setFamilyNameVisibility';
import { isPeselValid } from 'app/services/pesel.service';
import { CompletePersonData } from 'app/shared/interfaces/CompleteFormDataByKeys.interface';

function getPesel() {
  const completeDataFormValues = getCompleteDataFormValues();

  if (
    !completeDataFormValues.coowners ||
    !completeDataFormValues.coowners[2] ||
    !(completeDataFormValues.coowners[2] as CompletePersonData).pesel
  ) {
    return;
  }

  return (completeDataFormValues.coowners[2] as CompletePersonData)
    .pesel as string;
}

const secondCoownerDetails = {
  completeDataFormCoowners2PeselChange() {
    const pesel = getPesel();

    if (!pesel) {
      return;
    }

    const coowners = getQuotation().coOwners || [];
    const coowners2 = coowners[1] || {
      driverLicenseIssuedYear: 0,
      driverLicenseIssuedMonth: 0,
    };
    const driverLicenseYear = coowners2.driverLicenseIssuedYear;
    const driverLicenseMonth = coowners2.driverLicenseIssuedMonth;

    checkIfPeselIsMatchingLicenseDate({
      pesel,
      driverLicenseYear,
      driverLicenseMonth,
      noDriverLicenseModelPath: ModelPathEnum.Coowners2NoDriverLicense,
      messageKey:
        MessagesEnum.CompleteDataFormCoowners2PeselAndLicenseYearMismatch,
      formName: FormsEnum.CompleteDataForm,
    });
  },

  completeDataFormCoowners2CheckIfPeselIsMatchingGender() {
    const { coOwners } = getQuotation();
    const isOperator = getUserData().user?.operator;
    const pesel = getPesel();
    const genderNotSet = !coOwners || !coOwners[1] || !coOwners[1].gender;

    if (!pesel || genderNotSet || !isOperator) {
      return;
    }

    setFamilyNameVisibility(
      FieldsEnum.CompleteDataCoowners2FamilyName,
      FormsEnum.CompleteDataForm,
      pesel,
      isPeselValid(pesel)
    );
  },
};

export default secondCoownerDetails;
